System.register(["./dyn-jsx-runtime.js", "./dyn-index.js", "./dyn-embla-carousel-react.esm.js", "./dyn-goober.modern.js", "./dyn-index2.js"], function(exports, module) {
  "use strict";
  var jsxRuntimeExports, clsx, reactExports, useEmblaCarousel, u, useMobile;
  return {
    setters: [(module2) => {
      jsxRuntimeExports = module2.j;
      clsx = module2.c;
    }, (module2) => {
      reactExports = module2.r;
    }, (module2) => {
      useEmblaCarousel = module2.u;
    }, (module2) => {
      u = module2.u;
    }, (module2) => {
      useMobile = module2.u;
    }],
    execute: function() {
      var __vite_style__ = document.createElement("style");
      __vite_style__.textContent = "/*! tailwindcss v4.1.4 | MIT License | https://tailwindcss.com */\n._root_1o868_2{--slide-height:460px;--slide-size:390px;--slide-spacing:0;margin:auto auto 80px}@media not all and (min-width:48rem){._root_1o868_2{--slide-height:80vw;--slide-size:90vw;--slide-spacing:10px;margin-bottom:0}}._viewport_1o868_8{padding:48px 10px 20px;position:relative;overflow:hidden}._container_1o868_16{touch-action:pan-x pinch-zoom;margin-left:calc(var(--slide-spacing)*-1);margin-right:calc(var(--slide-spacing)*-1);display:flex}._navigator_1o868_23{--expand-width:0;margin-left:calc(var(--expand-width)*-1);margin-top:-24px;margin-right:calc(var(--expand-width)*-1)}@media not all and (min-width:48rem){._navigator_1o868_23{display:none}}._navigator_1o868_23 svg{pointer-events:none;width:100%}/*$vite$:1*/";
      document.head.appendChild(__vite_style__);
      const useDotButton = (emblaApi) => {
        const [selectedIndex, setSelectedIndex] = reactExports.useState(0);
        const [scrollSnaps, setScrollSnaps] = reactExports.useState([]);
        const onDotButtonClick = reactExports.useCallback((index) => {
          if (!emblaApi) return;
          emblaApi.scrollTo(index);
        }, [emblaApi]);
        const onInit = reactExports.useCallback((emblaApi2) => {
          setScrollSnaps(emblaApi2.scrollSnapList());
        }, []);
        const onSelect = reactExports.useCallback((emblaApi2) => {
          setSelectedIndex(emblaApi2.selectedScrollSnap());
        }, []);
        reactExports.useEffect(() => {
          if (!emblaApi) return;
          onInit(emblaApi);
          onSelect(emblaApi);
          emblaApi.on("reInit", onInit).on("reInit", onSelect).on("select", onSelect);
        }, [emblaApi, onInit, onSelect]);
        return {
          selectedIndex,
          scrollSnaps,
          onDotButtonClick
        };
      };
      const defaultOptions$1 = {
        active: true,
        breakpoints: {},
        delay: 4e3,
        jump: false,
        playOnInit: true,
        stopOnFocusIn: true,
        stopOnInteraction: true,
        stopOnMouseEnter: false,
        stopOnLastSnap: false,
        rootNode: null
      };
      function normalizeDelay(emblaApi, delay) {
        const scrollSnaps = emblaApi.scrollSnapList();
        if (typeof delay === "number") {
          return scrollSnaps.map(() => delay);
        }
        return delay(scrollSnaps, emblaApi);
      }
      function getAutoplayRootNode(emblaApi, rootNode) {
        const emblaRootNode = emblaApi.rootNode();
        return rootNode && rootNode(emblaRootNode) || emblaRootNode;
      }
      function Autoplay(userOptions = {}) {
        let options;
        let emblaApi;
        let destroyed;
        let delay;
        let timerStartTime = null;
        let timerId = 0;
        let autoplayActive = false;
        let mouseIsOver = false;
        let playOnDocumentVisible = false;
        let jump = false;
        function init(emblaApiInstance, optionsHandler) {
          emblaApi = emblaApiInstance;
          const {
            mergeOptions,
            optionsAtMedia
          } = optionsHandler;
          const optionsBase = mergeOptions(defaultOptions$1, Autoplay.globalOptions);
          const allOptions = mergeOptions(optionsBase, userOptions);
          options = optionsAtMedia(allOptions);
          if (emblaApi.scrollSnapList().length <= 1) return;
          jump = options.jump;
          destroyed = false;
          delay = normalizeDelay(emblaApi, options.delay);
          const {
            eventStore,
            ownerDocument
          } = emblaApi.internalEngine();
          const isDraggable = !!emblaApi.internalEngine().options.watchDrag;
          const root2 = getAutoplayRootNode(emblaApi, options.rootNode);
          eventStore.add(ownerDocument, "visibilitychange", visibilityChange);
          if (isDraggable) {
            emblaApi.on("pointerDown", pointerDown);
          }
          if (isDraggable && !options.stopOnInteraction) {
            emblaApi.on("pointerUp", pointerUp);
          }
          if (options.stopOnMouseEnter) {
            eventStore.add(root2, "mouseenter", mouseEnter);
          }
          if (options.stopOnMouseEnter && !options.stopOnInteraction) {
            eventStore.add(root2, "mouseleave", mouseLeave);
          }
          if (options.stopOnFocusIn) {
            emblaApi.on("slideFocusStart", stopAutoplay);
          }
          if (options.stopOnFocusIn && !options.stopOnInteraction) {
            eventStore.add(emblaApi.containerNode(), "focusout", startAutoplay);
          }
          if (options.playOnInit) startAutoplay();
        }
        function destroy() {
          emblaApi.off("pointerDown", pointerDown).off("pointerUp", pointerUp).off("slideFocusStart", stopAutoplay);
          stopAutoplay();
          destroyed = true;
          autoplayActive = false;
        }
        function setTimer() {
          const {
            ownerWindow
          } = emblaApi.internalEngine();
          ownerWindow.clearTimeout(timerId);
          timerId = ownerWindow.setTimeout(next, delay[emblaApi.selectedScrollSnap()]);
          timerStartTime = (/* @__PURE__ */ new Date()).getTime();
          emblaApi.emit("autoplay:timerset");
        }
        function clearTimer() {
          const {
            ownerWindow
          } = emblaApi.internalEngine();
          ownerWindow.clearTimeout(timerId);
          timerId = 0;
          timerStartTime = null;
          emblaApi.emit("autoplay:timerstopped");
        }
        function startAutoplay() {
          if (destroyed) return;
          if (documentIsHidden()) {
            playOnDocumentVisible = true;
            return;
          }
          if (!autoplayActive) emblaApi.emit("autoplay:play");
          setTimer();
          autoplayActive = true;
        }
        function stopAutoplay() {
          if (destroyed) return;
          if (autoplayActive) emblaApi.emit("autoplay:stop");
          clearTimer();
          autoplayActive = false;
        }
        function visibilityChange() {
          if (documentIsHidden()) {
            playOnDocumentVisible = autoplayActive;
            return stopAutoplay();
          }
          if (playOnDocumentVisible) startAutoplay();
        }
        function documentIsHidden() {
          const {
            ownerDocument
          } = emblaApi.internalEngine();
          return ownerDocument.visibilityState === "hidden";
        }
        function pointerDown() {
          if (!mouseIsOver) stopAutoplay();
        }
        function pointerUp() {
          if (!mouseIsOver) startAutoplay();
        }
        function mouseEnter() {
          mouseIsOver = true;
          stopAutoplay();
        }
        function mouseLeave() {
          mouseIsOver = false;
          startAutoplay();
        }
        function play(jumpOverride) {
          if (typeof jumpOverride !== "undefined") jump = jumpOverride;
          startAutoplay();
        }
        function stop() {
          if (autoplayActive) stopAutoplay();
        }
        function reset() {
          if (autoplayActive) startAutoplay();
        }
        function isPlaying() {
          return autoplayActive;
        }
        function next() {
          const {
            index
          } = emblaApi.internalEngine();
          const nextIndex = index.clone().add(1).get();
          const lastIndex = emblaApi.scrollSnapList().length - 1;
          const kill = options.stopOnLastSnap && nextIndex === lastIndex;
          if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext(jump);
          } else {
            emblaApi.scrollTo(0, jump);
          }
          emblaApi.emit("autoplay:select");
          if (kill) return stopAutoplay();
          startAutoplay();
        }
        function timeUntilNext() {
          if (!timerStartTime) return null;
          const currentDelay = delay[emblaApi.selectedScrollSnap()];
          const timePastSinceStart = (/* @__PURE__ */ new Date()).getTime() - timerStartTime;
          return currentDelay - timePastSinceStart;
        }
        const self = {
          name: "autoplay",
          options: userOptions,
          init,
          destroy,
          play,
          stop,
          reset,
          isPlaying,
          timeUntilNext
        };
        return self;
      }
      Autoplay.globalOptions = void 0;
      function _extends() {
        _extends = Object.assign || function(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        };
        return _extends.apply(this, arguments);
      }
      var DECAY = 0.996;
      var projection = function projection2(velocityPxMs, decay) {
        if (decay === void 0) {
          decay = DECAY;
        }
        return velocityPxMs * decay / (1 - decay);
      };
      function lastOf(array) {
        return array[array.length - 1];
      }
      function average(numbers) {
        return numbers.reduce(function(a, b) {
          return a + b;
        }) / numbers.length;
      }
      var clamp = function clamp2(value, min, max) {
        return Math.min(Math.max(min, value), max);
      };
      function addVectors(v1, v2) {
        if (v1.length !== v2.length) {
          throw new Error("vectors must be same length");
        }
        return v1.map(function(val, i) {
          return val + v2[i];
        });
      }
      function absMax(numbers) {
        return Math.max.apply(Math, numbers.map(Math.abs));
      }
      function deepFreeze(o) {
        Object.freeze(o);
        Object.values(o).forEach(function(value) {
          if (value !== null && typeof value === "object" && !Object.isFrozen(value)) {
            deepFreeze(value);
          }
        });
        return o;
      }
      function EventBus() {
        var listeners = {};
        function on(type, listener) {
          listeners[type] = (listeners[type] || []).concat(listener);
          return function() {
            return off(type, listener);
          };
        }
        function off(type, listener) {
          listeners[type] = (listeners[type] || []).filter(function(l) {
            return l !== listener;
          });
        }
        function dispatch(type, data) {
          if (!(type in listeners)) return;
          listeners[type].forEach(function(l) {
            return l(data);
          });
        }
        return deepFreeze({
          on,
          off,
          dispatch
        });
      }
      function WheelTargetObserver(eventListener) {
        var targets = [];
        var observe = function observe2(target) {
          target.addEventListener("wheel", eventListener, {
            passive: false
          });
          targets.push(target);
          return function() {
            return unobserve(target);
          };
        };
        var unobserve = function unobserve2(target) {
          target.removeEventListener("wheel", eventListener);
          targets = targets.filter(function(t) {
            return t !== target;
          });
        };
        var disconnect = function disconnect2() {
          targets.forEach(unobserve);
        };
        return deepFreeze({
          observe,
          unobserve,
          disconnect
        });
      }
      var LINE_HEIGHT = 16 * 1.125;
      var PAGE_HEIGHT = typeof window !== "undefined" && window.innerHeight || 800;
      var DELTA_MODE_UNIT = [1, LINE_HEIGHT, PAGE_HEIGHT];
      function normalizeWheel(e) {
        var deltaX = e.deltaX * DELTA_MODE_UNIT[e.deltaMode];
        var deltaY = e.deltaY * DELTA_MODE_UNIT[e.deltaMode];
        var deltaZ = (e.deltaZ || 0) * DELTA_MODE_UNIT[e.deltaMode];
        return {
          timeStamp: e.timeStamp,
          axisDelta: [deltaX, deltaY, deltaZ]
        };
      }
      var reverseAll = [-1, -1, -1];
      function reverseAxisDeltaSign(wheel, reverseSign) {
        if (!reverseSign) {
          return wheel;
        }
        var multipliers = reverseSign === true ? reverseAll : reverseSign.map(function(shouldReverse) {
          return shouldReverse ? -1 : 1;
        });
        return _extends({}, wheel, {
          axisDelta: wheel.axisDelta.map(function(delta, i) {
            return delta * multipliers[i];
          })
        });
      }
      var DELTA_MAX_ABS = 700;
      var clampAxisDelta = function clampAxisDelta2(wheel) {
        return _extends({}, wheel, {
          axisDelta: wheel.axisDelta.map(function(delta) {
            return clamp(delta, -700, DELTA_MAX_ABS);
          })
        });
      };
      var ACC_FACTOR_MIN = 0.6;
      var ACC_FACTOR_MAX = 0.96;
      var WHEELEVENTS_TO_MERGE = 2;
      var WHEELEVENTS_TO_ANALAZE = 5;
      var configDefaults = /* @__PURE__ */ deepFreeze({
        preventWheelAction: true,
        reverseSign: [true, true, false]
      });
      var WILL_END_TIMEOUT_DEFAULT = 400;
      function createWheelGesturesState() {
        return {
          isStarted: false,
          isStartPublished: false,
          isMomentum: false,
          startTime: 0,
          lastAbsDelta: Infinity,
          axisMovement: [0, 0, 0],
          axisVelocity: [0, 0, 0],
          accelerationFactors: [],
          scrollPoints: [],
          scrollPointsToMerge: [],
          willEndTimeout: WILL_END_TIMEOUT_DEFAULT
        };
      }
      function WheelGestures(optionsParam) {
        if (optionsParam === void 0) {
          optionsParam = {};
        }
        var _EventBus = EventBus(), on = _EventBus.on, off = _EventBus.off, dispatch = _EventBus.dispatch;
        var config = configDefaults;
        var state = createWheelGesturesState();
        var currentEvent;
        var negativeZeroFingerUpSpecialEvent = false;
        var prevWheelEventState;
        var feedWheel = function feedWheel2(wheelEvents) {
          if (Array.isArray(wheelEvents)) {
            wheelEvents.forEach(function(wheelEvent) {
              return processWheelEventData(wheelEvent);
            });
          } else {
            processWheelEventData(wheelEvents);
          }
        };
        var updateOptions = function updateOptions2(newOptions) {
          if (newOptions === void 0) {
            newOptions = {};
          }
          if (Object.values(newOptions).some(function(option) {
            return option === void 0 || option === null;
          })) {
            return config;
          }
          return config = deepFreeze(_extends({}, configDefaults, config, newOptions));
        };
        var publishWheel = function publishWheel2(additionalData) {
          var wheelEventState = _extends({
            event: currentEvent,
            isStart: false,
            isEnding: false,
            isMomentumCancel: false,
            isMomentum: state.isMomentum,
            axisDelta: [0, 0, 0],
            axisVelocity: state.axisVelocity,
            axisMovement: state.axisMovement,
            get axisMovementProjection() {
              return addVectors(wheelEventState.axisMovement, wheelEventState.axisVelocity.map(function(velocity) {
                return projection(velocity);
              }));
            }
          }, additionalData);
          dispatch("wheel", _extends({}, wheelEventState, {
            previous: prevWheelEventState
          }));
          prevWheelEventState = wheelEventState;
        };
        var shouldPreventDefault = function shouldPreventDefault2(deltaMaxAbs, axisDelta) {
          var _config = config, preventWheelAction = _config.preventWheelAction;
          var deltaX = axisDelta[0], deltaY = axisDelta[1], deltaZ = axisDelta[2];
          if (typeof preventWheelAction === "boolean") return preventWheelAction;
          switch (preventWheelAction) {
            case "x":
              return Math.abs(deltaX) >= deltaMaxAbs;
            case "y":
              return Math.abs(deltaY) >= deltaMaxAbs;
            case "z":
              return Math.abs(deltaZ) >= deltaMaxAbs;
            default:
              return false;
          }
        };
        var processWheelEventData = function processWheelEventData2(wheelEvent) {
          var _clampAxisDelta = clampAxisDelta(reverseAxisDeltaSign(normalizeWheel(wheelEvent), config.reverseSign)), axisDelta = _clampAxisDelta.axisDelta, timeStamp = _clampAxisDelta.timeStamp;
          var deltaMaxAbs = absMax(axisDelta);
          if (wheelEvent.preventDefault && shouldPreventDefault(deltaMaxAbs, axisDelta)) {
            wheelEvent.preventDefault();
          }
          if (!state.isStarted) {
            start();
          } else if (state.isMomentum && deltaMaxAbs > Math.max(2, state.lastAbsDelta * 2)) {
            end(true);
            start();
          }
          if (deltaMaxAbs === 0 && Object.is && Object.is(wheelEvent.deltaX, -0)) {
            negativeZeroFingerUpSpecialEvent = true;
            return;
          }
          currentEvent = wheelEvent;
          state.axisMovement = addVectors(state.axisMovement, axisDelta);
          state.lastAbsDelta = deltaMaxAbs;
          state.scrollPointsToMerge.push({
            axisDelta,
            timeStamp
          });
          mergeScrollPointsCalcVelocity();
          publishWheel({
            axisDelta,
            isStart: !state.isStartPublished
          });
          state.isStartPublished = true;
          willEnd();
        };
        var mergeScrollPointsCalcVelocity = function mergeScrollPointsCalcVelocity2() {
          if (state.scrollPointsToMerge.length === WHEELEVENTS_TO_MERGE) {
            state.scrollPoints.unshift({
              axisDeltaSum: state.scrollPointsToMerge.map(function(b) {
                return b.axisDelta;
              }).reduce(addVectors),
              timeStamp: average(state.scrollPointsToMerge.map(function(b) {
                return b.timeStamp;
              }))
            });
            updateVelocity();
            state.scrollPointsToMerge.length = 0;
            state.scrollPoints.length = 1;
            if (!state.isMomentum) {
              detectMomentum();
            }
          } else if (!state.isStartPublished) {
            updateStartVelocity();
          }
        };
        var updateStartVelocity = function updateStartVelocity2() {
          state.axisVelocity = lastOf(state.scrollPointsToMerge).axisDelta.map(function(d) {
            return d / state.willEndTimeout;
          });
        };
        var updateVelocity = function updateVelocity2() {
          var _state$scrollPoints = state.scrollPoints, latestScrollPoint = _state$scrollPoints[0], prevScrollPoint = _state$scrollPoints[1];
          if (!prevScrollPoint || !latestScrollPoint) {
            return;
          }
          var deltaTime = latestScrollPoint.timeStamp - prevScrollPoint.timeStamp;
          if (deltaTime <= 0) {
            return;
          }
          var velocity = latestScrollPoint.axisDeltaSum.map(function(d) {
            return d / deltaTime;
          });
          var accelerationFactor = velocity.map(function(v, i) {
            return v / (state.axisVelocity[i] || 1);
          });
          state.axisVelocity = velocity;
          state.accelerationFactors.push(accelerationFactor);
          updateWillEndTimeout(deltaTime);
        };
        var updateWillEndTimeout = function updateWillEndTimeout2(deltaTime) {
          var newTimeout = Math.ceil(deltaTime / 10) * 10 * 1.2;
          if (!state.isMomentum) {
            newTimeout = Math.max(100, newTimeout * 2);
          }
          state.willEndTimeout = Math.min(1e3, Math.round(newTimeout));
        };
        var accelerationFactorInMomentumRange = function accelerationFactorInMomentumRange2(accFactor) {
          if (accFactor === 0) return true;
          return accFactor <= ACC_FACTOR_MAX && accFactor >= ACC_FACTOR_MIN;
        };
        var detectMomentum = function detectMomentum2() {
          if (state.accelerationFactors.length >= WHEELEVENTS_TO_ANALAZE) {
            if (negativeZeroFingerUpSpecialEvent) {
              negativeZeroFingerUpSpecialEvent = false;
              if (absMax(state.axisVelocity) >= 0.2) {
                recognizedMomentum();
                return;
              }
            }
            var recentAccelerationFactors = state.accelerationFactors.slice(WHEELEVENTS_TO_ANALAZE * -1);
            var detectedMomentum = recentAccelerationFactors.every(function(accFac) {
              var sameAccFac = !!accFac.reduce(function(f1, f2) {
                return f1 && f1 < 1 && f1 === f2 ? 1 : 0;
              });
              var bothAreInRangeOrZero = accFac.filter(accelerationFactorInMomentumRange).length === accFac.length;
              return sameAccFac || bothAreInRangeOrZero;
            });
            if (detectedMomentum) {
              recognizedMomentum();
            }
            state.accelerationFactors = recentAccelerationFactors;
          }
        };
        var recognizedMomentum = function recognizedMomentum2() {
          state.isMomentum = true;
        };
        var start = function start2() {
          state = createWheelGesturesState();
          state.isStarted = true;
          state.startTime = Date.now();
          prevWheelEventState = void 0;
          negativeZeroFingerUpSpecialEvent = false;
        };
        var willEnd = /* @__PURE__ */ function() {
          var willEndId;
          return function() {
            clearTimeout(willEndId);
            willEndId = setTimeout(end, state.willEndTimeout);
          };
        }();
        var end = function end2(isMomentumCancel) {
          if (isMomentumCancel === void 0) {
            isMomentumCancel = false;
          }
          if (!state.isStarted) return;
          if (state.isMomentum && isMomentumCancel) {
            publishWheel({
              isEnding: true,
              isMomentumCancel: true
            });
          } else {
            publishWheel({
              isEnding: true
            });
          }
          state.isMomentum = false;
          state.isStarted = false;
        };
        var _WheelTargetObserver = WheelTargetObserver(feedWheel), observe = _WheelTargetObserver.observe, unobserve = _WheelTargetObserver.unobserve, disconnect = _WheelTargetObserver.disconnect;
        updateOptions(optionsParam);
        return deepFreeze({
          on,
          off,
          observe,
          unobserve,
          disconnect,
          feedWheel,
          updateOptions
        });
      }
      var defaultOptions = {
        active: true,
        breakpoints: {},
        wheelDraggingClass: "is-wheel-dragging",
        forceWheelAxis: void 0,
        target: void 0
      };
      WheelGesturesPlugin.globalOptions = void 0;
      function WheelGesturesPlugin(userOptions) {
        if (userOptions === void 0) {
          userOptions = {};
        }
        var options;
        var cleanup = function cleanup2() {
        };
        function init(embla, optionsHandler) {
          var _options$target, _options$forceWheelAx;
          var mergeOptions = optionsHandler.mergeOptions, optionsAtMedia = optionsHandler.optionsAtMedia;
          var optionsBase = mergeOptions(defaultOptions, WheelGesturesPlugin.globalOptions);
          var allOptions = mergeOptions(optionsBase, userOptions);
          options = optionsAtMedia(allOptions);
          var engine = embla.internalEngine();
          var targetNode = (_options$target = options.target) != null ? _options$target : embla.containerNode().parentNode;
          var wheelAxis = (_options$forceWheelAx = options.forceWheelAxis) != null ? _options$forceWheelAx : engine.options.axis;
          var wheelGestures = WheelGestures({
            preventWheelAction: wheelAxis,
            reverseSign: [true, true, false]
          });
          var unobserveTargetNode = wheelGestures.observe(targetNode);
          var offWheel = wheelGestures.on("wheel", handleWheel);
          var isStarted = false;
          var startEvent;
          function wheelGestureStarted(state) {
            try {
              startEvent = new MouseEvent("mousedown", state.event);
              dispatchEvent(startEvent);
            } catch (e) {
              return cleanup();
            }
            isStarted = true;
            addNativeMouseEventListeners();
            if (options.wheelDraggingClass) {
              targetNode.classList.add(options.wheelDraggingClass);
            }
          }
          function wheelGestureEnded(state) {
            isStarted = false;
            dispatchEvent(createRelativeMouseEvent("mouseup", state));
            removeNativeMouseEventListeners();
            if (options.wheelDraggingClass) {
              targetNode.classList.remove(options.wheelDraggingClass);
            }
          }
          function addNativeMouseEventListeners() {
            document.documentElement.addEventListener("mousemove", preventNativeMouseHandler, true);
            document.documentElement.addEventListener("mouseup", preventNativeMouseHandler, true);
            document.documentElement.addEventListener("mousedown", preventNativeMouseHandler, true);
          }
          function removeNativeMouseEventListeners() {
            document.documentElement.removeEventListener("mousemove", preventNativeMouseHandler, true);
            document.documentElement.removeEventListener("mouseup", preventNativeMouseHandler, true);
            document.documentElement.removeEventListener("mousedown", preventNativeMouseHandler, true);
          }
          function preventNativeMouseHandler(e) {
            if (isStarted && e.isTrusted) {
              e.stopImmediatePropagation();
            }
          }
          function createRelativeMouseEvent(type, state) {
            var moveX, moveY;
            if (wheelAxis === engine.options.axis) {
              var _state$axisMovement = state.axisMovement;
              moveX = _state$axisMovement[0];
              moveY = _state$axisMovement[1];
            } else {
              var _state$axisMovement2 = state.axisMovement;
              moveY = _state$axisMovement2[0];
              moveX = _state$axisMovement2[1];
            }
            if (!engine.options.skipSnaps && !engine.options.dragFree) {
              var maxX = engine.containerRect.width;
              var maxY = engine.containerRect.height;
              moveX = moveX < 0 ? Math.max(moveX, -maxX) : Math.min(moveX, maxX);
              moveY = moveY < 0 ? Math.max(moveY, -maxY) : Math.min(moveY, maxY);
            }
            return new MouseEvent(type, {
              clientX: startEvent.clientX + moveX,
              clientY: startEvent.clientY + moveY,
              screenX: startEvent.screenX + moveX,
              screenY: startEvent.screenY + moveY,
              movementX: moveX,
              movementY: moveY,
              button: 0,
              bubbles: true,
              cancelable: true,
              composed: true
            });
          }
          function dispatchEvent(event) {
            embla.containerNode().dispatchEvent(event);
          }
          function handleWheel(state) {
            var _state$axisDelta = state.axisDelta, deltaX = _state$axisDelta[0], deltaY = _state$axisDelta[1];
            var primaryAxisDelta = wheelAxis === "x" ? deltaX : deltaY;
            var crossAxisDelta = wheelAxis === "x" ? deltaY : deltaX;
            var isRelease = state.isMomentum && state.previous && !state.previous.isMomentum;
            var isEndingOrRelease = state.isEnding && !state.isMomentum || isRelease;
            var primaryAxisDeltaIsDominant = Math.abs(primaryAxisDelta) > Math.abs(crossAxisDelta);
            if (primaryAxisDeltaIsDominant && !isStarted && !state.isMomentum) {
              wheelGestureStarted(state);
            }
            if (!isStarted) return;
            if (isEndingOrRelease) {
              wheelGestureEnded(state);
            } else {
              dispatchEvent(createRelativeMouseEvent("mousemove", state));
            }
          }
          cleanup = function cleanup2() {
            unobserveTargetNode();
            offWheel();
            removeNativeMouseEventListeners();
          };
        }
        var self = {
          name: "wheelGestures",
          options: userOptions,
          init,
          destroy: function destroy() {
            return cleanup();
          }
        };
        return self;
      }
      const ArcSvg = '<svg width="1209" height="177" viewBox="0 0 1209 177" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M202.513 125.742C202.656 124.368 203.885 123.371 205.258 123.514C311.436 134.552 451.263 141.26 604.5 141.26C757.737 141.26 897.564 134.552 1003.74 123.514C1005.11 123.371 1006.34 124.368 1006.49 125.742C1006.63 127.115 1005.63 128.344 1004.26 128.487C897.869 139.547 757.863 146.26 604.5 146.26C451.136 146.26 311.131 139.547 204.741 128.487C203.368 128.344 202.371 127.115 202.513 125.742Z" fill="#40495C" />\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M202.513 125.742C202.656 124.368 203.885 123.371 205.258 123.514C311.436 134.552 451.263 141.26 604.5 141.26C757.737 141.26 897.564 134.552 1003.74 123.514C1005.11 123.371 1006.34 124.368 1006.49 125.742C1006.63 127.115 1005.63 128.344 1004.26 128.487C897.869 139.547 757.863 146.26 604.5 146.26C451.136 146.26 311.131 139.547 204.741 128.487C203.368 128.344 202.371 127.115 202.513 125.742Z" fill="url(#paint0_radial_111_555)" />\n  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.4968 67.4297C5.70805 69.4924 5 71.3381 5 73C5 74.724 5.76311 76.6495 7.70599 78.807C9.66179 80.9789 12.6901 83.2402 16.8732 85.5442C25.2359 90.1502 37.722 94.6631 54.0043 98.9895C86.5295 107.632 133.636 115.386 191.775 121.808C193.147 121.96 194.136 123.195 193.985 124.568C193.833 125.94 192.598 126.93 191.225 126.778C132.997 120.346 85.6033 112.559 52.7203 103.822C36.2986 99.4584 23.3534 94.8216 14.461 89.9238C10.0166 87.4759 6.46133 84.8967 3.99046 82.1529C1.50667 79.3947 0 76.3291 0 73C0 69.7949 1.39761 66.8312 3.71932 64.1539C6.02682 61.493 9.34543 58.9932 13.4887 56.622C21.7762 51.8791 33.8373 47.3861 49.141 43.1489C79.7873 34.6636 124.016 27.0502 178.531 20.6659C287.595 7.89349 438.197 0 604.5 0C770.803 0 921.405 7.89349 1030.47 20.6659C1084.98 27.0502 1129.21 34.6636 1159.86 43.1489C1175.16 47.3861 1187.22 51.8791 1195.51 56.622C1199.65 58.9932 1202.97 61.493 1205.28 64.1539C1207.6 66.8312 1209 69.7949 1209 73C1209 76.3291 1207.49 79.3947 1205.01 82.1529C1202.54 84.8967 1198.98 87.4759 1194.54 89.9238C1185.65 94.8216 1172.7 99.4584 1156.28 103.822C1123.4 112.559 1076 120.346 1017.77 126.778C1016.4 126.93 1015.17 125.94 1015.02 124.568C1014.86 123.195 1015.85 121.96 1017.23 121.808C1075.36 115.386 1122.47 107.632 1155 98.9895C1171.28 94.6631 1183.76 90.1502 1192.13 85.5442C1196.31 83.2402 1199.34 80.9789 1201.29 78.807C1203.24 76.6495 1204 74.724 1204 73C1204 71.3381 1203.29 69.4924 1201.5 67.4297C1199.7 65.3506 1196.9 63.1798 1193.03 60.9616C1185.28 56.5258 1173.68 52.1648 1158.52 47.9676C1128.25 39.5839 1084.31 32.0057 1029.89 25.632C921.07 12.8885 770.672 5 604.5 5C438.328 5 287.93 12.8885 179.113 25.632C124.687 32.0057 80.7547 39.5839 50.4752 47.9676C35.3161 52.1648 23.7231 56.5258 15.9723 60.9616C12.0964 63.1798 9.29976 65.3506 7.4968 67.4297Z" fill="url(#paint1_linear_111_555)" />\n  <path d="M1197.8 87H1187.26C1179.19 90.7545 1168.37 94.435 1155 97.9895C1122.47 106.632 1075.36 114.386 1017.23 120.808C1015.85 120.96 1014.86 122.195 1015.02 123.568C1015.17 124.94 1016.4 125.93 1017.77 125.778C1076 119.346 1123.4 111.559 1156.28 102.822C1172.7 98.4584 1185.65 93.8216 1194.54 88.9238C1195.69 88.2915 1196.78 87.6504 1197.8 87Z" fill="url(#paint0_radial_111_555)"/>\n  <path d="M21.741 87H11.1982C12.2243 87.6504 13.313 88.2915 14.461 88.9238C23.3534 93.8216 36.2986 98.4584 52.7203 102.822C85.6033 111.559 132.997 119.346 191.225 125.778C192.598 125.93 193.833 124.94 193.985 123.568C194.136 122.195 193.147 120.96 191.774 120.808C133.636 114.386 86.5295 106.632 54.0043 97.9895C40.6269 94.435 29.812 90.7545 21.741 87Z" fill="url(#paint0_radial_111_555)"/>\n  <g filter="url(#filter0_d_111_555)">\n    <circle cx="518" cy="142" r="10" fill="#35EBFF"/>\n  </g>\n  <g style="mix-blend-mode: plus-lighter" filter="url(#filter1_f_111_555)">\n    <circle cx="518" cy="142" r="10" fill="#00BBFF"/>\n  </g>\n  <g style="mix-blend-mode: plus-lighter" filter="url(#filter2_f_111_555)">\n    <circle cx="518" cy="142" r="10" fill="#00BBFF"/>\n  </g>\n  <defs>\n  <filter id="filter0_d_111_555" x="504" y="132" width="28" height="28" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n    <feFlood flood-opacity="0" result="BackgroundImageFix" />\n    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>\n    <feOffset dy="4"/>\n    <feGaussianBlur stdDeviation="2"/>\n    <feComposite in2="hardAlpha" operator="out"/>\n    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>\n    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_111_555"/>\n    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_111_555" result="shape"/>\n  </filter>\n  <filter id="filter1_f_111_555" x="485.6" y="109.6" width="64.8" height="64.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n    <feFlood flood-opacity="0" result="BackgroundImageFix"/>\n    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\n    <feGaussianBlur stdDeviation="11.2" result="effect1_foregroundBlur_111_555"/>\n  </filter>\n  <filter id="filter2_f_111_555" x="483.6" y="107.6" width="68.8" height="68.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">\n    <feFlood flood-opacity="0" result="BackgroundImageFix"/>\n    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>\n    <feGaussianBlur stdDeviation="12.2" result="effect1_foregroundBlur_111_555"/>\n  </filter>\n  <radialGradient id="paint0_radial_111_555" cx="0" cy="0" r="168" gradientUnits="userSpaceOnUse" gradientTransform="translate(520 141)">\n    <stop stop-color="#35EBFF" stop-opacity="0"/>\n    <stop stop-color="#35EBFF" stop-opacity="0"/>\n    <stop stop-color="#35EBFF"/>\n    <stop offset="1" stop-opacity="0"/>\n  </radialGradient>\n  <linearGradient id="paint1_linear_111_555" x1="604.5" y1="148.5" x2="604.5" y2="0.500002" gradientUnits="userSpaceOnUse">\n    <stop stop-color="#40495C"/>\n    <stop offset="1" stop-opacity="0"/>\n  </linearGradient>\n  </defs>\n</svg>';
      const root = "_root_1o868_2";
      const viewport = "_viewport_1o868_8";
      const container = "_container_1o868_16";
      const navigator = "_navigator_1o868_23";
      const styles = {
        root,
        viewport,
        container,
        navigator
      };
      const classes = {
        content: u`/* content */`,
        avatar: u`/* avatar */`
      };
      const slideCls = clsx("min-w-0", u`
  transform: translate3d(0, 0, 0);
  flex: 0 0 var(--slide-size);
  padding-left: var(--slide-spacing);
  padding-right: var(--slide-spacing);
  padding-bottom: 24px;
  &[data-distance="1"],
  &[data-distance="2"],
  &[data-distance="3"] {
    .${classes.content} {
      border-radius: 32px;
    }
    .${classes.avatar} {
      opacity: 0;
    }
    .carousel-slide-content-info {
      opacity: 0;
    }
    .carousel-slide-content-bg {
      opacity: 1;
    }
  }
  &[data-distance="3"] {
    opacity: 0;
  }
  .${classes.avatar},
  .carousel-slide-content-info,
  .carousel-slide-content-bg {
    transition: opacity 0.3s ease;
  }
  box-sizing: border-box;
  perspective: 1200px;
  .carousel-slide-content {
    position: relative;
    display: flex;
    background: linear-gradient(180deg, #BAC7D2 13.09%, rgba(2, 2, 2, 0) 100%);
    box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
    border-radius: 15px;
    font-size: 4rem;
    font-weight: 600;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    min-height: var(--slide-height);
    user-select: none;
    box-sizing: border-box;
    transition: transform border-radius .3s ease;
    &:before {
      border-radius: inherit;
      content: '';
      position: absolute;
      background: linear-gradient(180deg, #181B22 0%, #0C0D10 100%);
      left: 2px;
      top: 2px;
      right: 2px;
      bottom: 2px;
      z-index: 1;
    }
  }
  .${classes.avatar} {
    position: relative;
    border-radius: 999px;
    width: 184px;
    height: 184px;
    margin: 0 auto;
    overflow: hidden;
    margin-top: -28px;
    z-index: 2;
    flex-shrink: 0;
    background: linear-gradient(180deg, #BAC7D2 13.09%, rgba(2, 2, 2, 0) 100%);
    img {
      position: absolute;
      top: 4px;
      left: 4px;
      right: 4px;
      bottom: 4px;
      width: 176px;
      height: 176px;
      border-radius: inherit;
      object-fit: cover;
      object-position: center center;
    }
    @media screen and (max-width: 767px) {
      width: 92px;
      height: 92px;
      margin-top: -24px;
      img {
        top: 2px;
        left: 2px;
        right: 2px;
        bottom: 2px;
        width: 88px;
        height: 88px;
      }
    }
  }
  .carousel-slide-content-info {
    position: relative;
    margin-top: 18px;
    text-align: center;
    max-width: 336px;
    z-index: 3;
    h5 {
      font-weight: 600;
      font-size: 26px;
      line-height: 120%;
    }
    .info-icon {
      line-height: 1;
      font-size: 0;
    }
    img {
      width: 32px;
      height: auto;
    }
    a {
      display: inline-block;
      background: linear-gradient(90deg, #35EBFF 0%, #025BFF 100%);
      font-weight: 600;
      font-size: 18px;
      line-height: 150%;
      color: white;
      border-radius: 999px;
      text-align: center;
      padding: 8.5px 24px;
      overflow: hidden;
      margin: 0;
      margin-top: 8px;
      vertical-align: top;
    }
    .info-desc {
      margin-top: 28px;
      font-weight: 400;
      font-size: 14px;
      line-height: 170%;
      min-height: 96px;
    }
    @media screen and (max-width: 767px) {
      width: 90%;
      a {
        width: 100%;
      }
      .info-desc {
        line-height: 1.25;
        min-height: 96px;
      }
      .info-icon {
        position: absolute;
        top: -64px;
        right: 0;
        img {
          vertical-align: top;
        }
      }
    }
  }
  .carousel-slide-content-bg {
    position: absolute;
    left: 2px;
    right: 2px;
    top: 1px;
    bottom: 1px;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    border-bottom-left-radius: inherit;
    border-bottom-right-radius: inherit;
    opacity: 0;
    overflow: hidden;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      opacity: .3;
      filter: grayscale(1);
    }
  }
`);
      const navigatorNamesCls = u`
  position: relative;
  display: flex;
  justify-content: space-around;
  div {
    position: absolute;
    left: -9999px;
    max-width: 12.5%;
    white-space: break-spaces;
    word-wrap: break-word;
    word-break: break-word;
    text-align: center;
    cursor: pointer;
  }
  @media screen and (max-width: 767px) {
    display: none;
  }
`;
      const mobileNavigatorCls = u`
  display: flex;
  padding: 0 46px;
  flex-wrap: wrap;
  justify-content: center;
  justify-items: center;
  --slide-size: 33.33%;
  &.columns-4 {
    --slide-size: 25%;
  }
  div {
    flex: 1 1 var(--slide-size);
    position: relative;
    overflow: hidden;
    margin-left: 5px;
    margin-right: 5px;
    max-width: ${60 / 375 * 100}vw;
    height: ${60 / 375 * 100}vw;
    padding: 3.2px;
    border-radius: 999px;
    box-sizing: border-box;
    margin-bottom: 10px;
    &.active {
      background: linear-gradient(90deg, #35EBFF 0%, #025BFF 100%);
    }
  }
  img {
    width: 100%;
    height: 100%;
    border-radius: inherit;
    object-fit: cover;
    object-position: center center;
  }
`;
      const ECLIPSE_A = 1209 / 2;
      const ECLIPSE_B = 146.26 / 2;
      const getEclipseY = (x, a, b) => {
        return Math.sqrt((1 - x * x / (a * a)) * b * b);
      };
      const Media3DCarousel = exports("default", (props) => {
        const {
          slides,
          options
        } = props;
        const rootRef = reactExports.useRef(null);
        const isMobile = useMobile();
        const [emblaRef, emblaApi] = useEmblaCarousel(options, [Autoplay({
          delay: 1e4,
          stopOnInteraction: true
        }), WheelGesturesPlugin()]);
        const {
          selectedIndex,
          onDotButtonClick
        } = useDotButton(emblaApi);
        reactExports.useEffect(() => {
          if (!emblaApi) return;
          const ANGLE = 90;
          const MIN_SCALE = 0.8333;
          const OFFSET = 90;
          const END_X = 1209 - OFFSET;
          const RANGE = END_X - OFFSET;
          const rootEl = rootRef.current;
          const snapList = emblaApi.scrollSnapList();
          const length = snapList.length;
          const expandedSnapList = snapList.concat(snapList.map((v) => v + 1));
          const nodes = emblaApi.slideNodes();
          const HALF = Math.floor(length / 2);
          const slideWidth = nodes[0].offsetWidth;
          const circles = Array.from(rootRef.current.querySelectorAll("svg circle"));
          const filter0 = rootEl.querySelector("svg #filter0_d_111_555");
          const filter = rootEl.querySelector("svg #filter1_f_111_555");
          const filter2 = rootEl.querySelector("svg #filter2_f_111_555");
          const calcX = (p) => {
            const SEG = emblaApi.scrollSnapList()[1];
            return (Math.max(0.05, Math.min(0.95, p + SEG / 2)) - 0.5) * RANGE;
          };
          Array.from(rootEl.querySelectorAll(`.${navigatorNamesCls} div`)).forEach((el, index) => {
            const progress = snapList[index];
            const X = calcX(progress);
            const Y = getEclipseY(X, ECLIPSE_A, ECLIPSE_B);
            el.style.position = "absolute";
            el.style.left = `${(X + ECLIPSE_A) / (ECLIPSE_A * 2) * 100}%`;
            el.style.transform = `translateX(-50%) translateY(-${ECLIPSE_B - Y}px)`;
          });
          function updateTransform(api) {
            var _a;
            if (isMobile) return;
            const SEG = snapList[1];
            const progress = api.scrollProgress();
            const closestIndex = (() => {
              let [min, result] = [1, -1];
              expandedSnapList.forEach((v, index) => {
                const diff = Math.abs(v - progress);
                if (diff < min) {
                  [min, result] = [diff, index];
                }
              });
              return result;
            })();
            const X = calcX(progress);
            const Y = getEclipseY(X, ECLIPSE_A, ECLIPSE_B);
            circles.forEach((circle) => {
              circle.setAttribute("cx", `${X + ECLIPSE_A}`);
              circle.setAttribute("cy", `${(Y || 0) + ECLIPSE_B - 3}`);
            });
            filter0 == null ? void 0 : filter0.setAttribute("x", `${X + ECLIPSE_A - 14}`);
            filter0 == null ? void 0 : filter0.setAttribute("y", `${(Y || 0) + ECLIPSE_B - 14}`);
            filter == null ? void 0 : filter.setAttribute("x", `${X + ECLIPSE_A - 32}`);
            filter == null ? void 0 : filter.setAttribute("y", `${(Y || 0) + ECLIPSE_B - 32}`);
            filter2 == null ? void 0 : filter2.setAttribute("x", `${X + ECLIPSE_A - 34.4}`);
            filter2 == null ? void 0 : filter2.setAttribute("y", `${(Y || 0) + ECLIPSE_B - 34.4}`);
            (_a = rootRef.current.querySelector("svg #paint0_radial_111_555")) == null ? void 0 : _a.setAttribute("gradientTransform", `translate(${X + ECLIPSE_A} ${Y + ECLIPSE_B})`);
            for (let i = closestIndex - HALF; i < closestIndex - HALF + length; i++) {
              const snap = i < 0 ? snapList[i + length] - 1 : expandedSnapList[i];
              const node = i < 0 ? nodes[i + length] : nodes[i % length];
              const distance = i - closestIndex;
              const direction = distance > 0 ? -1 : 1;
              const slideContent = node.querySelector(".carousel-slide-content");
              const rotateFactor = Math.round(direction * Math.abs(progress - snap) * 100) / 100;
              const angle = Math.min(Math.max(rotateFactor * ANGLE, -45), 45);
              const scale = Math.min(1, Math.max(1 - Math.abs(progress - snap) / SEG * (1 - MIN_SCALE), MIN_SCALE));
              node.style.zIndex = `${HALF - Math.abs(distance)}`;
              node.dataset.distance = `${Math.min(3, Math.abs(distance))}`;
              const translateX = slideWidth * 0.5 * ((progress - snap) / SEG);
              slideContent.style.transform = `scale(${scale}) translateX(${translateX}px) rotateY(${angle}deg)`;
            }
          }
          emblaApi.on("slidesInView", firstSettle);
          emblaApi.on("scroll", updateTransform);
          emblaApi.on("autoplay:select", updateTransform);
          function firstSettle(api) {
            updateTransform(api);
            setTimeout(() => {
              api.off("slidesInView", firstSettle);
            });
          }
          return () => {
            emblaApi.off("scroll", updateTransform);
            emblaApi.off("autoplay:play", updateTransform);
            nodes.forEach((node) => {
              node.style.zIndex = "";
              node.querySelector(".carousel-slide-content").style.transform = "";
            });
          };
        }, [emblaApi, isMobile]);
        return /* @__PURE__ */ jsxRuntimeExports.jsxs("section", { className: styles.root, ref: rootRef, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.viewport, ref: emblaRef, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.container, children: slides.map((slide, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: slideCls, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel-slide-content", onClick: () => {
            emblaApi == null ? void 0 : emblaApi.scrollTo(index);
          }, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx(classes.avatar), children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: slide.image, alt: slide.title }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "carousel-slide-content-info", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("h5", { children: slide.title }),
              slide.icon ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "info-icon", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: slide.icon }) }) : null,
              slide.desc ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "info-desc", dangerouslySetInnerHTML: {
                __html: slide.desc
              } }) : null,
              slide.link && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("a", { href: slide.link, target: "_blank", children: slide.link_text }) })
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "carousel-slide-content-bg", children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: slide.image, alt: slide.title }) })
          ] }) }, index)) }) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles.navigator, dangerouslySetInnerHTML: {
            __html: ArcSvg
          } }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: navigatorNamesCls, children: slides.map((slide, index) => {
            return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: () => emblaApi == null ? void 0 : emblaApi.scrollTo(index), children: slide.title }, slide.title);
          }) }),
          isMobile && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx(mobileNavigatorCls, slides.length > 6 && "columns-4"), children: slides.map((slide, index) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: clsx({
            active: selectedIndex === index
          }), onClick: () => onDotButtonClick(index), children: /* @__PURE__ */ jsxRuntimeExports.jsx("img", { src: slide.image }) }, index)) })
        ] });
      });
    }
  };
});
